// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';

// Primereact imports
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Styling
import './communication.scss';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';
import { getCommunicationList } from '../../redux/actions/communication';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';
import { isMobileOnly } from 'react-device-detect';

class CommunicationPage extends Component {

    componentDidMount() {
        this.props.getCommunicationList(this.props.registrationRef);
    }

    dateBodyTemplate(rowData) {
        return rowData.communicationDate !== undefined ? rowData.communicationDate.replace('T',' ') : "";
    }

    render() {
        return (
            <div>
                <PageTitleComponent title={this.props.t("communication.title")} />
                  <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                      <div className='col-1'></div>
                      <div className="col-10">
                          <div className="card mgt-20">
                            {
                              this.props.communications !== null ? 
                                  <DataTable value={this.props.communications} paginator className="p-datatable-gridlines" showGridlines rows={10} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("communication.messages.no-communications")}>
                                      <Column field="communicationDate" header={this.props.t("communication.form.date-header")} body={(data) => this.dateBodyTemplate(data)} style={{ minWidth: '12rem' }} />
                                      <Column field="message" header={this.props.t("communication.form.message-header")} style={{ minWidth: '12rem' }}  />
                                  </DataTable>
                              : null
                            }
                          </div>
                      </div>
                      <div className='col-1'></div>
                  </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {
      communications: state.communication.communications,
      registrationRef: state.authentication.registrationRef
  } 
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCommunicationList: (registrationRef) => { dispatch(getCommunicationList(registrationRef)) }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(authenticationChecker(withTranslation(CommunicationPage)));